import { TableBody, TableRow } from '@sanlam-glacier/app-common/components';
import { EmptyData } from 'modules/new-business/components/pages/empty-data/EmptyData';

type EmptyProposalsProps = {
  search: string | undefined;
  numberOfColumns: number;
};

export const EmptyProposals = ({ search, numberOfColumns }: EmptyProposalsProps) => {
  return (
    <TableBody>
      <TableRow>
        <td colSpan={numberOfColumns}>
          <EmptyData searchTerm={search} />
        </td>
      </TableRow>
    </TableBody>
  );
};
